/**
 * useCanManageProcessDefinitions — czy user widzi wejścia do definicji procesów
 * (Ustawienia → Ogólne „Definicje procesów", przycisk na stronie Akceptacji,
 * link „Zobacz wszystkie" w widgecie dashboardu „Czekające decyzje").
 *
 * Warunek: `isSuperUser` LUB permission `processes.definitions.view` (dziś zawsze
 * `false` — `GET /api/auth/me` nie zwraca jeszcze realnych uprawnień, patrz
 * `docs/architecture/AUTH.md` — ale sprawdzamy od razu, żeby nie trzeba było
 * wracać do trzech miejsc gdy backend zacznie je zwracać), ORAZ aktywna
 * subskrypcja modułu `processes` (status `active`/`trialing`, jak `getActiveModules`
 * po stronie API).
 */
import { type TenantMeResponse, useTenantAuth } from '@/contexts/TenantAuthContext';

/** Czysta wersja (bez kontekstu) — dla miejsc, które mają `me` z opcjonalnego kontekstu. */
export function canManageProcessDefinitions(me: TenantMeResponse | null | undefined): boolean {
  const isSuperUser = me?.user.isSuperUser === true;
  const hasPermission = me?.permissions.includes('processes.definitions.view') ?? false;
  const isModuleActive = me?.modules.some((m) => m.code === 'processes') ?? false;
  return (isSuperUser || hasPermission) && isModuleActive;
}

export function useCanManageProcessDefinitions(): boolean {
  const { me } = useTenantAuth();
  return canManageProcessDefinitions(me);
}
